<div class="dialog-header">
    <h6>Matter document list</h6>
    <mat-icon class="close-icon" (click)="closeDialog()">close</mat-icon>
</div>

<div *ngIf="isLoading" class="loading-container">
    <mat-progress-bar mode="indeterminate" color="primary"></mat-progress-bar>
    <p>Loading documents, please wait...</p>
</div>

<div class="table-scroll-container">
    <div *ngIf="!isLoading && documents.data.length > 0" class="document-table-container ">

        <table mat-table class="document-table" [dataSource]="documents">
            <ng-container matColumnDef="document">
                <th mat-header-cell *matHeaderCellDef class="column-document pointer" (click)="sortDocuments('name')">
                    <span class="d-flex align-items-center">
                        <span>Document Name</span>
                        <span *ngIf="currentSortColumn === 'name'">
                            <mat-icon style="height: 15px;" *ngIf="sortDirection === 'asc'">keyboard_arrow_up</mat-icon>
                            <mat-icon style="height: 15px;" *ngIf="sortDirection !== 'asc'">keyboard_arrow_down</mat-icon>
                        </span>
                    </span>
                </th>
                <td mat-cell *matCellDef="let document" class="column-document">
                    <mat-checkbox [checked]="isSelected(document)"
                                  [disabled]="!isAllowedExtension(document)"
                                  (change)="toggleSelection(document, $event.checked)" class="">
                        {{ document.name }}{{ document.extension }}
                    </mat-checkbox>
                </td>
            </ng-container>

            <ng-container matColumnDef="date">
                <th mat-header-cell *matHeaderCellDef class="column-date custom-date-width pointer" (click)="sortDocuments('date')">
                    <span class="d-flex align-items-center">
                        <span>Date</span>
                        <span *ngIf="currentSortColumn === 'date'">
                            <mat-icon style="height: 15px;" *ngIf="sortDirection === 'asc'">keyboard_arrow_up</mat-icon>
                            <mat-icon style="height: 15px;" *ngIf="sortDirection !== 'asc'">keyboard_arrow_down</mat-icon>
                        </span>
                    </span>
                </th>
                <td mat-cell *matCellDef="let document" class="column-date custom-date-width">
                    <span class="">{{ document.modifiedTimestamp | date: 'dd-MM-YYYY' }}</span>
                </td>
            </ng-container>

            <!--Role Selection Column-->
            <ng-container matColumnDef="role">
                <th mat-header-cell *matHeaderCellDef class="column-role custom-document-width"> Type </th>
                <td mat-cell *matCellDef="let document" class="column-role custom-document-width">
                    <mat-form-field class="document-dropdown">
                        <mat-label *ngIf="!selectedOption"> Type </mat-label>
                        <mat-select [(value)]="document.selectedOption" [disabled]="!isAllowedExtension(document)" [required]="isSelected(document)">
                            <mat-option *ngFor="let option of documentTypeOptions" [value]="option.value">{{ option.label }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </td>
            </ng-container>

            <!--Front/Back Selection Column-->
            <ng-container matColumnDef="side">
                <th mat-header-cell *matHeaderCellDef class="column-side custom-document-width"> Side </th>
                <td mat-cell *matCellDef="let document" class="column-side custom-document-width" [class.hidden]="document.selectedOption === 'Passport'">
                    <mat-form-field class="document-dropdown">
                        <mat-label *ngIf="!selectedSide"> Side </mat-label>
                        <!--<mat-select [(value)]="document.selectedSide">-->
                        <mat-select [(value)]="document.selectedSide"
                                    [required]="isSelected(document)"
                                    [disabled]="!isAllowedExtension(document)"
                                    (selectionChange)="toggleSelection(document, $event.value)">
                            <mat-option value="FRONT">Front</mat-option>
                            <mat-option value="BACK">Back</mat-option>
                        </mat-select>
                    </mat-form-field>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </div>
</div>
<div *ngIf="!isLoading && documents.data.length === 0" class="no-documents-placeholder">
    <p>No documents found</p>
</div>
<div mat-dialog-actions class="dialog-actions">
    <button mat-raised-button
            class="btn-verify"
            [disabled]="!allDocumentsSelected()|| documentType === 'POA'  && selectedDocuments.length === 0"
            [ngClass]="{'disabled-button': !allDocumentsSelected(), 'enabled-button': allDocumentsSelected()}"
            (click)="addSelectedDocuments()">
        Add
    </button>
    <button mat-raised-button
            class="btn-verify"
            [disabled]="!selectedDocuments.length"
            (click)="removeSelectedDocuments()">
        Clear Selection
    </button>
</div>
